import { SingleInvoice } from '~/Interfaces';
import initialState from '../initialState';
import {
  CONFIRM_SPLIT_PAYMENT_FAILED,
  CONFIRM_SPLIT_PAYMENT_STARTED,
  CONFIRM_SPLIT_PAYMENT_SUCCESS,
  CONFIRM_SPLIT_PAYMENT_IDLE,
  FETCH_SINGLE_INVOICE,
  InvoiceActon,
  SET_API_INVOICE_STATUS,
  CHOOSE_PAYMENT,
  SET_UBO_API_STATUS,
  SET_SIGNICAT_STATUS,
  UPDATE_UBO,
  UPDATE_DEBTOR_INVOICES,
  SET_API_DEBTOR_INVOICES_STATUS,
} from '../types/invoiceTypes';
import { ApiStatus } from '../types/sharedTypes';

interface FactoringState {
  readonly singleInvoice: SingleInvoice;
  readonly singleInvoicePDF: string;
  readonly singleInvoiceApiStatus: ApiStatus;
  readonly singleInvoiceAttachment: string;
  readonly confirmTermsAndConditionsApiStatus?: ApiStatus;
  readonly choosePaymentApiStatus?: ApiStatus;
  readonly uboApiStatus?: ApiStatus;
  readonly signicatApiStatus?: ApiStatus;
  readonly debtorInvoices: SingleInvoice[];
  readonly debtorInvoicesApiStatus?: ApiStatus;
  readonly debtorInvoicesTotalCount: number;
}

const factoringReducer = (
  state = initialState.factoring,
  action: InvoiceActon
): FactoringState => {
  switch (action.type) {
    case SET_API_INVOICE_STATUS:
      return {
        ...state,
        singleInvoiceApiStatus: action.payload,
      };

    case FETCH_SINGLE_INVOICE:
      return {
        ...state,
        singleInvoice: action.payload,
        singleInvoicePDF: action.payload.invoicePreview,
        singleInvoiceAttachment: action.payload.invoiceAttachment,
      };

    case UPDATE_UBO:
      return {
        ...state,
        singleInvoice: {
          ...state.singleInvoice,
          debtor: {
            ...state.singleInvoice.debtor,
            beneficialOwners: action.payload.beneficialOwners,
            beneficialOwnersChanged: action.payload.beneficialOwnersChanged,
          },
        },
      };

    case CONFIRM_SPLIT_PAYMENT_STARTED:
      return {
        ...state,
        confirmTermsAndConditionsApiStatus: ApiStatus.Started,
      };
    case CONFIRM_SPLIT_PAYMENT_SUCCESS:
      return {
        ...state,
        confirmTermsAndConditionsApiStatus: ApiStatus.Completed,
      };
    case CONFIRM_SPLIT_PAYMENT_FAILED:
      return {
        ...state,
        confirmTermsAndConditionsApiStatus: ApiStatus.Failed,
      };
    case CHOOSE_PAYMENT:
      return {
        ...state,
        choosePaymentApiStatus: action.payload,
      };
    case CONFIRM_SPLIT_PAYMENT_IDLE:
      return {
        ...state,
        confirmTermsAndConditionsApiStatus: ApiStatus.Idle,
      };
    case SET_UBO_API_STATUS:
      return {
        ...state,
        uboApiStatus: action.payload,
      };
    case SET_SIGNICAT_STATUS:
      return {
        ...state,
        signicatApiStatus: action.payload,
      };
    case UPDATE_DEBTOR_INVOICES:
      return {
        ...state,
        debtorInvoices: action.payload.concat
          ? [...state.debtorInvoices, ...action.payload.invoices]
          : action.payload.invoices,
        debtorInvoicesTotalCount: action.payload.count,
      };
    case SET_API_DEBTOR_INVOICES_STATUS:
      return {
        ...state,
        debtorInvoicesApiStatus: action.payload,
      };
    default:
      return state;
  }
};

export default factoringReducer;
